/** TypeBox instantiation metrics */
export const Metrics = {
    assign: 0,
    create: 0,
    clone: 0,
    discard: 0,
    update: 0
};
